var map = {
	"./add.svg": "c2a3",
	"./audioPlay.svg": "1942",
	"./audioStop.svg": "f616",
	"./cancel.svg": "8ed3",
	"./delete.svg": "59a1",
	"./down.svg": "d681",
	"./download.svg": "4dae",
	"./end.svg": "58db",
	"./folder.svg": "d079",
	"./preview.svg": "e6c2",
	"./refresh.svg": "b8c4",
	"./sound.svg": "1f6c",
	"./sound2.svg": "68e9",
	"./soundEnd.svg": "4681",
	"./soundStart.svg": "5117",
	"./start.svg": "2743",
	"./stop.svg": "bdb7",
	"./taskMenu.svg": "f114",
	"./user.svg": "b3b5",
	"./userRemove.svg": "584b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e81";